module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "top"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_vm._v("\n\t\t\t\t " + _vm._s(_vm.getErrorText) + " \n\t\t\t")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_vm._v(" ")])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('el-col', {
    staticClass: "video",
    attrs: {
      "span": 16
    }
  }, [_c('iframe', {
    attrs: {
      "width": "100%",
      "height": "100%",
      "src": "http://www.youtube.com/embed/SkgTxQm9DWM?autoplay=1&cc_load_policy=1",
      "frameborder": "0",
      "allowfullscreen": ""
    }
  })]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_vm._v(" ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4bbbbccf","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/project-error.vue
// module id = 714
// module chunks = 1